import Track from '@FreeRider/Track';
import Camera from '@FreeRider/Camera';
import Renderer from '@FreeRider/Renderers/Renderer';
import Screen from '@FreeRider/Screen';
import SectorRenderer from '@FreeRider/Renderers/SectorRenderer';

class TrackRenderer extends Renderer
{
    /**
     * Sector renderer
     * Used to draw and cache drawn sectors
     */
    private sectorRenderer: SectorRenderer;

    /**
     * Constructor
     * @param canvas - canvas to draw to
     */
    constructor(canvas:HTMLCanvasElement)
    {
        super(canvas);
        this.sectorRenderer = new SectorRenderer();
    }

    /**
     * Renders a track to canvas
     * @param track
     * @param x
     * @param y
     * @param width
     * @param height
     * @param zoom
     */
    public render(track: Track, camera: Camera, screen: Screen)
    {
        const x = camera.x;
        const y = camera.y;
        const zoom = camera.zoom;

        const width = screen.width;
        const height = screen.height;

        const trackSectors = track.sectors;

        const sectorSize = Track.SECTOR_SIZE * zoom;

        const centreColumn = x * zoom / sectorSize;
        const centreRow = y * zoom / sectorSize;

        const columns = width / sectorSize;
        const rows = height / sectorSize;

        const leftColumn = centreColumn - (columns / 2) - 1;
        const topRow = centreRow - (rows / 2) - 1;

        const rightColumn = centreColumn + (columns / 2);
        const bottomRow = centreColumn + (rows / 2);

        const offsetX = (centreColumn * sectorSize) - (width / 2);
        const offsetY = (centreRow * sectorSize) - (height / 2);

        const sectorCount = trackSectors.length;

        for (let i = 0; i < sectorCount; i++)
        {
            const sector = trackSectors[i];
            const sectorX = sector.x;
            const sectorY = sector.y;

            if (sectorX >= leftColumn &&
                sectorX <= rightColumn &&
                sectorY >= topRow &&
                sectorY <= bottomRow)
            {
                const drawX = (sectorX * sectorSize) - offsetX;
                const drawY = (sectorY * sectorSize) - offsetY;

                const sectorCanvas = this.sectorRenderer.render(sector, zoom);
                this.canvasCtx.drawImage(sectorCanvas, drawX, drawY, sectorSize, sectorSize);
            }
            else
            {
                this.sectorRenderer.clearCache(sector);
            }
        }
    }
}

export default TrackRenderer;